export default __webpack_public_path__ + "static/media/September2018.12e34d73.png";